import React, { Component } from 'react';
import '../assets/custom.css';
import LoginFields from '../LoginFields/LoginFields';
import { withRouter } from 'react-router-dom';
import logo from "../assets/images/logo_avenuepm.png";
import logo_ideasthatwork from "../assets/images/logo-bottom.png";
import REST from "../Shared/REST";
import {VERSION} from '../Shared/Consts';

class LoginComponent extends Component {

    constructor(props) {
        super(props);
        this.handleResources = this.handleResources.bind(this);
        this.handleRequestAccount = this.handleRequestAccount.bind(this);
        this.handleHelp = this.handleHelp.bind(this);
    }

    async componentDidMount(){
        let token = await localStorage.getItem('token');
        if (token) {
            await REST.authWithToken().then((response) => {
                if (response.success) {
                    console.log(response);
                    this.props.history.push('/');
                }
            });
        }
    }

    handleResources(){
        this.props.history.push("/resources");
    }

    handleRequestAccount(){
        this.props.history.push("/request-account");
    }

    handleHelp(){
        this.props.history.push("/help");
    }

    render() {
        return (
            <div>
                <h1 className="homePage"><img src={logo} alt="AvenuePM" border="0" /></h1>
                <div className="section bgGreen mainLogin">
                    <div className="container">
                        <div>
                            <h2 className="width">Student Management System</h2>
                            <div className="formContainer">
                                <LoginFields {...this.props} callbackFromParent={this.props.callback} />
                            </div>
                        </div>
                    </div>
                </div>

                <nav id="mainNavNonMobile" className="navbar navbar-custom">
                    <div className="container">
                        <div className="navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav">
                                <li onClick={this.handleRequestAccount}><a className="handBtn"><span>Request a Teacher Account</span></a></li>
                                <li onClick={this.handleHelp}><a className="handBtn"><span>Help</span></a></li>
                            </ul>
                        </div>
                    </div>
                </nav>

                <footer>
                    <div className="container">
                        <div className="col-lg-12">
                            <p>&copy; <script>new Date().getFullYear()>2010&&document.write(new Date().getFullYear());</script> Designed and developed by researchers at the North Carolina State University and Penn State University. (v.{VERSION})</p>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default withRouter(LoginComponent);